import type { BaseRoleEntity } from '@/features/baseRole/domain/entities/BaseRoleEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { Language } from '@/shared/entities/Language'
import type { Gender } from '@/shared/enums/genderEnum'

export class UserEntity {
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  id?: string
  displayName?: string | null
  email?: string | null
  phoneNumber?: string | null
  photoUrl?: string | null
  emailVerified?: boolean
  disabled?: boolean
  baseRoles?: Array<BaseRoleEntity> | null
  roles?: Array<BaseRoleEntity> | null
  language?: Language
  gender?: Gender
  regions?: RegionMiniEntity[]
}
